<template>
  <div class="page-container">
    <!-- 头部 -->
    <section>
      <com-header></com-header>
    </section>

    <!-- nav -->
    <section>
      <com-nav></com-nav>
    </section>

    <!-- 内容部分 -->
    <section>
      <!-- 视频 -->
      <div class="page-content video-content">
        <!-- <video src="../assets/bg.mp4" muted controls id="videodom" autoplay="autoplay" loop="loop"></video> -->
        <!-- <video ref="myVideo" id="myVideo" autoplay="muted" loop="loop" controlsclass="video-box">
          <source src="../assets/bg.mp4" type="video/mp4" />
        </video> -->
        <video src="http://www.borlandjewel.com/common/bg.mp4" id="myVideo" muted="muted" controls  autoplay="autoplay" loop="loop">
          您的浏览器不支持 video 标签。
        </video>
      </div>

      <!-- 底部信息 -->
      <div class="page-content bottom-info-content">
        <p>备案号：<a href="https://beian.miit.gov.cn" target="_blank">浙ICP备14043647号</a></p>
      </div>
    </section>
  </div>
</template>

<script>
import comHeader from "../components/comheader.vue";
import comNav from "../components/comnav.vue";
let myPlayer = null
export default {
  name: "index",
  data() {
    return {
      productList: [
        { url: require("../assets/product/1.jpg") },
        { url: require("../assets/product/2.jpg") },
        { url: require("../assets/product/3.jpg") },
        { url: require("../assets/product/4.jpg") },
        { url: require("../assets/product/5.jpg") },
        { url: require("../assets/product/6.jpg") },
      ],
    };
  },
  mounted() {
    this.initVideo();
  },
  methods: {
    initVideo() {
      let video = document.getElementById("myVideo")
      video && video.play();
    },
  },
  components: {
    comHeader: comHeader,
    comNav: comNav,
  },
  destroyed() {
    myPlayer && myPlayer.dispose()
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.page-container {
  width: 100%;
  height: 100%;
  background-color: #0a0020;
  .page-content {
    width: 100%;
  }
  .video-content {
    width: 100%;
    #myVideo {
      display: block;
      margin: 0;
      padding: 0;
      width: 100%;
      height: auto;
    }
  }
  .bottom-info-content {
    border-top: 2px solid #333;
    position: relative;
    height: 60px;
    background:#090909;
    display:flex;
    align-items: center;
    justify-content: center;
    color: #999;
    font-size: 12px;
    p:hover {
      color:#fff;
      a {
        color:#fff;
      }
    }
    a {
      color:#999;
      text-decoration: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue